import { render, staticRenderFns } from "./EditHotline.vue?vue&type=template&id=70912c51&scoped=true"
import script from "./EditHotline.vue?vue&type=script&lang=ts"
export * from "./EditHotline.vue?vue&type=script&lang=ts"
import style0 from "./EditHotline.vue?vue&type=style&index=0&id=70912c51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70912c51",
  null
  
)

export default component.exports